import { parseISO } from 'date-fns';

export const parseISOorDate = (value: Date | string): Date =>
  typeof value === 'string' ? parseISO(value) : value;
